import React from 'react';

import 'styled-components/macro';

import { ButtonProps } from '@nw/omega-design-system';

import { StyledButton } from './styledComponents';

const ButtonComponent: React.FC<ButtonProps> = React.memo(
  (props: ButtonProps) => {
    const { id, children, ...otherProps } = props;
    return (
      <StyledButton id={id} data-testid={id} {...otherProps}>
        {children}
      </StyledButton>
    );
  }
);

ButtonComponent.displayName = 'ButtonComponent';

export { ButtonComponent };
